import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EHealthService, KMEHRid } from 'src/app/services/e-health.service';
import { PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import * as moment from 'moment';

@Component({
  selector: 'app-e-health-transaction-dialog',
  templateUrl: './e-health-transaction-dialog.component.html',
  styleUrls: ['./e-health-transaction-dialog.component.scss']
})
export class EHealthTransactionDialogComponent implements OnInit {

  displayedColumns: string[] = ['source'];
  okButtonLabel = 'Récupérer';
  okButtonAction = 'retrieve';
  transaction = {
    images:[]
  };

  constructor(public dialogRef: MatDialogRef<EHealthTransactionDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public ehealth: EHealthService,
      public patient: PatientService,
      public dialog: MatDialog,
      public userConfig: UserConfigService) { }

  ngOnInit(): void {
  }

  getTransactionInfo(transaction)
  {
    var info = {
      type:'',
      desc:'',
      authors:'',
      date:''
    };
    transaction.cds.forEach(cds => {
      if (cds.s == 'CD-TRANSACTION')
      {
        info.type = cds.value;
      }
      if (cds.s == 'LOCAL' && cds.value.length != 0)
      {
        info.desc += cds.value;
      }
    });
    info.authors = transaction.authorsList;
    info.date = moment(transaction.date).format('DD/MM/YYYY')
    return info; 
  }

  getTransactionType(transaction)
  {
    return this.getTransactionInfo(transaction).type;
  }

  getTransactionDesc(transaction)
  {
    return this.getTransactionInfo(transaction).desc;
  }

  getTransactionAuthors(transaction)
  {
    return this.getTransactionInfo(transaction).authors;
  }

  getTransactionDate(transaction)
  {
    return this.getTransactionInfo(transaction).date;
  }

  selectTransaction(transaction)
  {
    this.ehealth.patientgettransaction(this.patient.patientid,new KMEHRid(transaction.ids[0].sv,transaction.ids[0].sl,transaction.ids[0].dn,transaction.ids[0].l,transaction.ids[0].value)).
      subscribe(result => {
        this.transaction.images = result[0].images;
      });
  }

  okButtonClicked()
  {
    if (this.okButtonAction == 'retrieve')
    {
      this.confirmImport();
    }
  }

  confirmImport()
  {
    // let dialogRef = this.dialog.open(ImportConfirmDialogComponent);
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result === 'import')
    //   {
    //     console.log('Start Import All');
    //     this.ehealth.starttransactionretrieving(this.patient.patientid);
    //   }
    // });        
  }

}
